<template>
  <fragment>
    <mc-app-header title="Challenge Attempts"></mc-app-header>
    <mc-app-body>
      <div class="challenge-attempts section">
        <mc-paginated-list resource-state="challengeAttempts">
          <div
            v-if="challengeAttempts.list.length === 0"
            class="box mc-container"
          >
            <div class="content has-text-centered">
              No challenge attempts available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(challengeAttempt, index) in challengeAttempts.list"
              :key="index"
              class="challenge-attempts__item box"
            >
              <div
                class="challenge-attempts__item-desc"
                :set="(attemptUser = challengeAttempt.user)"
              >
                <div class="challenge-attempts__item-title">
                  <span>{{ displayDetails(attemptUser) }}</span>
                </div>
                <b-field grouped group-multiline>
                  <div class="control">
                    <b-taglist>
                      <b-tag
                        v-if="challengeAttempt.score === undefined"
                        type="is-warning"
                        >In Progress</b-tag
                      >
                      <b-tag v-else type="is-info">Completed</b-tag>
                      <fragment
                        v-if="
                          challengeAttempt.score !== undefined &&
                            challengeAttempt.difficulty
                        "
                      >
                        <b-tag
                          v-if="
                            challengeAttempt.rereview !== undefined &&
                              challengeAttempt.reviews.length !== 2
                          "
                          type="is-danger"
                          >ReReview</b-tag
                        >
                        <b-tag
                          v-if="challengeAttempt.reviews.length === 2"
                          type="is-success"
                          >reviewed</b-tag
                        >
                      </fragment>
                    </b-taglist>
                  </div>
                  <div class="control">
                    <b-taglist attached>
                      <b-tag type="is-dark">type</b-tag>
                      <b-tag type="is-info">
                        {{ challengeTypeNames[challengeAttempt.difficulty] }}
                      </b-tag>
                    </b-taglist>
                  </div>
                </b-field>
              </div>
              <router-link
                v-if="challengeAttempt.score !== undefined"
                class="button is-link is-small"
                :to="`/challenge_attempts/${challengeAttempt.id}/review`"
                >Review</router-link
              >
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { challengeTypeNames } from './utils';
import { displayDetails } from '../../../utils/user';

export default {
  data() {
    return {
      challengeTypeNames
    };
  },
  computed: {
    ...mapState(['challengeAttempts']),
    challengeId() {
      return this.$route.params.id;
    }
  },
  created() {
    this.load();
  },
  methods: {
    ...mapActions('challengeAttempts', ['setFilter']),
    load() {
      this.setFilter({
        challenge: `/challenges/${this.challengeId}`
      });
    },
    displayDetails
  }
};
</script>

<style lang="scss" scoped>
.challenge-attempts {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title {
    margin-bottom: 0.5rem;
  }
}
</style>
